import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _sendActionCommandsEv;

import { ACTION_COMMANDS_EVENT_TYPE, ACTION_COMMANDS_TYPE } from '../constants';
import Logger from '../../../lib/analytics/logger';
import { EVENT_ACTIONS, EVENT_DOMAINS, EVENT_SCREENS, EVENT_WIDGETS } from '../../../lib/analytics/constants';

var sendMetrics = function sendMetrics(event, body) {
  return Logger.sendEvent(event, body);
};

var displayAppModalEvent = function displayAppModalEvent(modalType, _ref) {
  var executionId = _ref.executionId,
      triggerType = _ref.triggerType;
  return sendMetrics(ACTION_COMMANDS_EVENT_TYPE.DISPLAY_APP_MODAL, {
    action: EVENT_ACTIONS.DISPLAY,
    domain: modalType,
    screen: EVENT_SCREENS[EVENT_DOMAINS.ACTIONS_COMMANDS].APP_MODAL,
    trigger: triggerType,
    executionId: executionId
  });
};

var acceptAppModalEvent = function acceptAppModalEvent(modalType, _ref2) {
  var executionId = _ref2.executionId,
      triggerType = _ref2.triggerType;
  return sendMetrics(ACTION_COMMANDS_EVENT_TYPE.ACCEPT_APP_MODAL, {
    action: EVENT_ACTIONS.PRESS,
    domain: modalType,
    screen: EVENT_SCREENS[EVENT_DOMAINS.ACTIONS_COMMANDS].APP_MODAL,
    widget: EVENT_WIDGETS[EVENT_DOMAINS.ACTIONS_COMMANDS].ACCEPT_BUTTON,
    trigger: triggerType,
    executionId: executionId
  });
};

var dismissAppModalEvent = function dismissAppModalEvent(modalType, _ref3) {
  var _ref3$triggerExecutio = _ref3.triggerExecution,
      executionId = _ref3$triggerExecutio.executionId,
      triggerType = _ref3$triggerExecutio.triggerType;
  return sendMetrics(ACTION_COMMANDS_EVENT_TYPE.DISMISS_APP_MODAL, {
    action: EVENT_ACTIONS.PRESS,
    domain: modalType,
    screen: EVENT_SCREENS[EVENT_DOMAINS.ACTIONS_COMMANDS].APP_MODAL,
    widget: EVENT_WIDGETS[EVENT_DOMAINS.ACTIONS_COMMANDS].DISMISS_BUTTON,
    trigger: triggerType,
    executionId: executionId
  });
};

var displayNativeModalEvent = function displayNativeModalEvent(modalType, _ref4) {
  var _ref4$triggerExecutio = _ref4.triggerExecution,
      executionId = _ref4$triggerExecutio.executionId,
      triggerType = _ref4$triggerExecutio.triggerType;
  return sendMetrics(ACTION_COMMANDS_EVENT_TYPE.DISPLAY_NATIVE_MODAL, {
    action: EVENT_ACTIONS.DISPLAY,
    domain: modalType,
    screen: EVENT_SCREENS[EVENT_DOMAINS.ACTIONS_COMMANDS].NATIVE_MODAL,
    trigger: triggerType,
    executionId: executionId
  });
};

var acceptNativeModalEvent = function acceptNativeModalEvent(modalType, _ref5) {
  var _ref5$triggerExecutio = _ref5.triggerExecution,
      executionId = _ref5$triggerExecutio.executionId,
      triggerType = _ref5$triggerExecutio.triggerType;
  return sendMetrics(ACTION_COMMANDS_EVENT_TYPE.ACCEPT_NATIVE_MODAL, {
    action: EVENT_ACTIONS.PRESS,
    domain: modalType,
    screen: EVENT_SCREENS[EVENT_DOMAINS.ACTIONS_COMMANDS].NATIVE_MODAL,
    widget: EVENT_WIDGETS[EVENT_DOMAINS.ACTIONS_COMMANDS].ACCEPT_BUTTON,
    trigger: triggerType,
    executionId: executionId
  });
};

var dismissNativeModalEvent = function dismissNativeModalEvent(modalType, _ref6) {
  var _ref6$triggerExecutio = _ref6.triggerExecution,
      executionId = _ref6$triggerExecutio.executionId,
      triggerType = _ref6$triggerExecutio.triggerType;
  return sendMetrics(ACTION_COMMANDS_EVENT_TYPE.DISMISS_NATIVE_MODAL, {
    action: EVENT_ACTIONS.PRESS,
    domain: modalType,
    screen: EVENT_SCREENS[EVENT_DOMAINS.ACTIONS_COMMANDS].NATIVE_MODAL,
    widget: EVENT_WIDGETS[EVENT_DOMAINS.ACTIONS_COMMANDS].DISMISS_BUTTON,
    trigger: triggerType,
    executionId: executionId
  });
};

var signInEmailAppModalEvent = function signInEmailAppModalEvent(modalType, _ref7) {
  var _ref7$triggerExecutio = _ref7.triggerExecution,
      executionId = _ref7$triggerExecutio.executionId,
      triggerType = _ref7$triggerExecutio.triggerType;
  return sendMetrics(ACTION_COMMANDS_EVENT_TYPE.ACCEPT_APP_MODAL, {
    action: EVENT_ACTIONS.PRESS,
    domain: modalType,
    screen: EVENT_SCREENS[EVENT_DOMAINS.ACTIONS_COMMANDS].APP_MODAL,
    widget: EVENT_WIDGETS[EVENT_DOMAINS.ACTIONS_COMMANDS].SIGN_IN_EMAIL_BUTTON,
    trigger: triggerType,
    executionId: executionId
  });
};

var signInFacebookAppModalEvent = function signInFacebookAppModalEvent(modalType, _ref8) {
  var _ref8$triggerExecutio = _ref8.triggerExecution,
      executionId = _ref8$triggerExecutio.executionId,
      triggerType = _ref8$triggerExecutio.triggerType;
  return sendMetrics(ACTION_COMMANDS_EVENT_TYPE.ACCEPT_APP_MODAL, {
    action: EVENT_ACTIONS.PRESS,
    domain: modalType,
    screen: EVENT_SCREENS[EVENT_DOMAINS.ACTIONS_COMMANDS].APP_MODAL,
    widget: EVENT_WIDGETS[EVENT_DOMAINS.ACTIONS_COMMANDS].SIGN_IN_FACEBOOK_BUTTON,
    trigger: triggerType,
    executionId: executionId
  });
};

var signInGoogleAppModalEvent = function signInGoogleAppModalEvent(modalType, _ref9) {
  var _ref9$triggerExecutio = _ref9.triggerExecution,
      executionId = _ref9$triggerExecutio.executionId,
      triggerType = _ref9$triggerExecutio.triggerType;
  return sendMetrics(ACTION_COMMANDS_EVENT_TYPE.ACCEPT_APP_MODAL, {
    action: EVENT_ACTIONS.PRESS,
    domain: modalType,
    screen: EVENT_SCREENS[EVENT_DOMAINS.ACTIONS_COMMANDS].APP_MODAL,
    widget: EVENT_WIDGETS[EVENT_DOMAINS.ACTIONS_COMMANDS].SIGN_IN_GOOGLE_BUTTON,
    trigger: triggerType,
    executionId: executionId
  });
};

var signInAppleAppModalEvent = function signInAppleAppModalEvent(modalType, _ref10) {
  var _ref10$triggerExecuti = _ref10.triggerExecution,
      executionId = _ref10$triggerExecuti.executionId,
      triggerType = _ref10$triggerExecuti.triggerType;
  return sendMetrics(ACTION_COMMANDS_EVENT_TYPE.ACCEPT_APP_MODAL, {
    action: EVENT_ACTIONS.PRESS,
    domain: modalType,
    screen: EVENT_SCREENS[EVENT_DOMAINS.ACTIONS_COMMANDS].APP_MODAL,
    widget: EVENT_WIDGETS[EVENT_DOMAINS.ACTIONS_COMMANDS].SIGN_IN_APPLE_BUTTON,
    trigger: triggerType,
    executionId: executionId
  });
};

var skipOnboardingTutorial = function skipOnboardingTutorial(modalType, _ref11) {
  var executionId = _ref11.executionId,
      triggerType = _ref11.triggerType;
  sendMetrics(ACTION_COMMANDS_EVENT_TYPE.SKIP_ONBOARDING_TUTORIAL, {
    action: EVENT_ACTIONS.PRESS,
    domain: ACTION_COMMANDS_TYPE.DISPLAY_GAME_TUTORIAL,
    screen: EVENT_SCREENS[EVENT_DOMAINS.ACTIONS_COMMANDS].ONBOARDING_TUTORIAL,
    widget: EVENT_WIDGETS[EVENT_DOMAINS.ACTIONS_COMMANDS].SKIP_ONBOARDING_TUTORIAL,
    trigger: triggerType,
    executionId: executionId
  });
};

var completeOnboardingTutorial = function completeOnboardingTutorial(modalType, _ref12) {
  var executionId = _ref12.executionId,
      triggerType = _ref12.triggerType;
  sendMetrics(ACTION_COMMANDS_EVENT_TYPE.COMPLETE_ONBOARDING_TUTORIAL, {
    action: EVENT_ACTIONS.PRESS,
    domain: ACTION_COMMANDS_TYPE.DISPLAY_GAME_TUTORIAL,
    screen: EVENT_SCREENS[EVENT_DOMAINS.ACTIONS_COMMANDS].ONBOARDING_TUTORIAL,
    widget: EVENT_WIDGETS[EVENT_DOMAINS.ACTIONS_COMMANDS].COMPLETE_ONBOARDING_TUTORIAL,
    trigger: triggerType,
    executionId: executionId
  });
};

var skipMissionsTutorial = function skipMissionsTutorial(modalType, _ref13) {
  var executionId = _ref13.executionId,
      triggerType = _ref13.triggerType;
  sendMetrics(ACTION_COMMANDS_EVENT_TYPE.SKIP_MISSIONS_TUTORIAL, {
    action: EVENT_ACTIONS.PRESS,
    domain: ACTION_COMMANDS_TYPE.DISPLAY_MISSIONS_TUTORIAL,
    screen: EVENT_SCREENS[EVENT_DOMAINS.ACTIONS_COMMANDS].MISSIONS_TUTORIAL,
    widget: EVENT_WIDGETS[EVENT_DOMAINS.ACTIONS_COMMANDS].SKIP_MISSIONS_TUTORIAL,
    trigger: triggerType,
    executionId: executionId
  });
};

var completeMissionsTutorial = function completeMissionsTutorial(modalType, _ref14) {
  var executionId = _ref14.executionId,
      triggerType = _ref14.triggerType;
  sendMetrics(ACTION_COMMANDS_EVENT_TYPE.COMPLETE_MISSIONS_TUTORIAL, {
    action: EVENT_ACTIONS.PRESS,
    domain: ACTION_COMMANDS_TYPE.DISPLAY_MISSIONS_TUTORIAL,
    screen: EVENT_SCREENS[EVENT_DOMAINS.ACTIONS_COMMANDS].MISSIONS_TUTORIAL,
    widget: EVENT_WIDGETS[EVENT_DOMAINS.ACTIONS_COMMANDS].COMPLETE_MISSIONS_TUTORIAL,
    trigger: triggerType,
    executionId: executionId
  });
};

var displayAppTooltipEvent = function displayAppTooltipEvent(modalType, _ref15) {
  var executionId = _ref15.executionId,
      triggerType = _ref15.triggerType;
  sendMetrics(ACTION_COMMANDS_EVENT_TYPE.DISPLAY_APP_TOOLTIP, {
    action: EVENT_ACTIONS.DISPLAY,
    domain: ACTION_COMMANDS_TYPE.DISPLAY_TOOLTIP,
    screen: EVENT_SCREENS[EVENT_DOMAINS.ACTIONS_COMMANDS].APP_TOOLTIP,
    trigger: triggerType,
    executionId: executionId
  });
};

export var sendActionCommandsEvent = (_sendActionCommandsEv = {}, _defineProperty(_sendActionCommandsEv, ACTION_COMMANDS_EVENT_TYPE.DISPLAY_APP_MODAL, displayAppModalEvent), _defineProperty(_sendActionCommandsEv, ACTION_COMMANDS_EVENT_TYPE.ACCEPT_APP_MODAL, acceptAppModalEvent), _defineProperty(_sendActionCommandsEv, ACTION_COMMANDS_EVENT_TYPE.DISMISS_APP_MODAL, dismissAppModalEvent), _defineProperty(_sendActionCommandsEv, ACTION_COMMANDS_EVENT_TYPE.DISPLAY_NATIVE_MODAL, displayNativeModalEvent), _defineProperty(_sendActionCommandsEv, ACTION_COMMANDS_EVENT_TYPE.ACCEPT_NATIVE_MODAL, acceptNativeModalEvent), _defineProperty(_sendActionCommandsEv, ACTION_COMMANDS_EVENT_TYPE.DISMISS_NATIVE_MODAL, dismissNativeModalEvent), _defineProperty(_sendActionCommandsEv, ACTION_COMMANDS_EVENT_TYPE.SIGN_IN_EMAIL_APP_MODAL, signInEmailAppModalEvent), _defineProperty(_sendActionCommandsEv, ACTION_COMMANDS_EVENT_TYPE.SIGN_IN_FACEBOOK_APP_MODAL, signInFacebookAppModalEvent), _defineProperty(_sendActionCommandsEv, ACTION_COMMANDS_EVENT_TYPE.SIGN_IN_GOOGLE_APP_MODAL, signInGoogleAppModalEvent), _defineProperty(_sendActionCommandsEv, ACTION_COMMANDS_EVENT_TYPE.SIGN_IN_APPLE_APP_MODAL, signInAppleAppModalEvent), _defineProperty(_sendActionCommandsEv, ACTION_COMMANDS_EVENT_TYPE.SKIP_ONBOARDING_TUTORIAL, skipOnboardingTutorial), _defineProperty(_sendActionCommandsEv, ACTION_COMMANDS_EVENT_TYPE.COMPLETE_ONBOARDING_TUTORIAL, completeOnboardingTutorial), _defineProperty(_sendActionCommandsEv, ACTION_COMMANDS_EVENT_TYPE.SKIP_MISSIONS_TUTORIAL, skipMissionsTutorial), _defineProperty(_sendActionCommandsEv, ACTION_COMMANDS_EVENT_TYPE.COMPLETE_MISSIONS_TUTORIAL, completeMissionsTutorial), _defineProperty(_sendActionCommandsEv, ACTION_COMMANDS_EVENT_TYPE.DISPLAY_APP_TOOLTIP, displayAppTooltipEvent), _sendActionCommandsEv);